// @flow
import React from 'react';
import FinalTranscript from './ScribeFinalTranscript';

type PropsFinal = {
  currentPlatform: string,
  features: FeatureMap,
  fontSize: number,
  lang: string,
  speakers: Object,
  theme: Object,
  transcripts: TranscriptMap,
  transcriptsFinal: Array<string>,
  user: Object,
  electronCaptionMode: boolean,
};

// eslint-disable-next-line react/no-multi-comp
class FinalTranscriptList extends React.Component<PropsFinal> {
  shouldComponentUpdate(nextProps: PropsFinal) {
    const { transcriptsFinal, fontSize, theme, lang, speakers } = this.props;
    if (
      fontSize !== nextProps.fontSize ||
      theme !== nextProps.theme ||
      lang !== nextProps.lang ||
      speakers !== nextProps.speakers
    ) {
      return true;
    }
    return transcriptsFinal.length !== nextProps.transcriptsFinal.length;
  }

  render() {
    const {
      currentPlatform,
      features,
      fontSize,
      lang,
      speakers,
      theme,
      transcripts,
      transcriptsFinal,
      user,
      electronCaptionMode,
    } = this.props;
    return transcriptsFinal.map<Object>(tid => (
      <FinalTranscript
        currentPlatform={currentPlatform}
        features={features}
        fontSize={fontSize}
        key={transcripts[tid].id}
        lang={lang}
        speaker={speakers[transcripts[tid].author]}
        theme={theme}
        transcript={transcripts[tid]}
        user={user}
        electronCaptionMode={electronCaptionMode}
      />
    ));
  }
}

export default FinalTranscriptList;
